/**
 * Generates an array of formatted pension option strings from the given state object.
 *
 * Each pension option is represented as a string in the format: "name - type".
 * Only pensions with both a valid name and type are included.
 *
 * @param {Object} state - The state object containing a pensions array.
 * @param {Array<Object>} [state.pensions] - Array of pension objects, each with 'name' and 'type' properties.
 * @returns {string[]} An array of formatted pension option strings.
 */
const getPensionOptions = (state) => {
  const pensionOptions = (state.pensions || [])
    .filter((p) => p.name && p.type)
    .map((p) => `${p.name.trim()} - ${p.type.trim()}`);

  return [...pensionOptions];
};

export default getPensionOptions;
